
(function () {
  'use strict';

  var HOVER_EVENTS = ['mouseenter', 'mouseleave'];

  var HOVER_TARGETS = '.menu__item, .submenu__item, sht-menu-header';

  function guard() {
    var drawer = document.getElementById('menuDrawer');

    if (!drawer || drawer.dataset.clickOnlyGuard === 'true') return;
    drawer.dataset.clickOnlyGuard = 'true';

    HOVER_EVENTS.forEach(function (type) {
      drawer.addEventListener(
        type,
        function (event) {
          // Only the menu accordions -- leave every other drawer hover alone.
          if (!event.target.matches || !event.target.matches(HOVER_TARGETS)) return;
          event.stopPropagation();
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guard);
  } else {
    guard();
  }
})();
